import { Bubble, Button, Flex, Image, Icon } from '@chatui/core';
import './style.css';

export interface ButtonProps {
  text: string;
  onClick: () => void;
  color?: 'primary';
  disabled?: boolean;
  icon?: React.ReactNode;
}
interface ActionCardProps {
  title?: string;
  image?: string;
  description?: string;
  actionButtons?: ButtonProps[];
  titleIcon?: string;
  children?: React.ReactNode;
}
const ActionCard = (props: ActionCardProps) => {
  const { title, image, description, actionButtons, titleIcon, children } =
    props;
  return (
    <Bubble
      style={{
        width: '100%',
      }}
    >
      <div className="action-card">
        <h4>
          <span>
            {titleIcon && (
              <Icon type={titleIcon} className="action-title-icon" />
            )}
            {title}
          </span>
        </h4>
        {image && <Image src={image} alt="" fluid />}
        {description && <p>{description}</p>}
        {children && children}
        {actionButtons && (
          <Flex center>
            {props.actionButtons?.map((button, i) => (
              <Button
                onClick={button.onClick}
                key={i}
                color={button.color}
                disabled={button.disabled || false}
                style={{ margin: '10px' }}
              >
                {button.icon}
                {button.text}
              </Button>
            ))}
          </Flex>
        )}
      </div>
    </Bubble>
  );
};

export default ActionCard;
